import "./LabValues.module.css";
import Header from "@/reusable_sections/Header";
import LabValuesDirectory from "./sections/LabValuesDirectory";
import CtaSubscribeForUpdates from "./sections/CtaSubscribeForUpdates";
import Footer from "@/reusable_sections/Footer";
export default function LabValuesPage() {
  return <div>
      <Header />
      <LabValuesDirectory />
      <CtaSubscribeForUpdates />
      <Footer />
    </div>;
}